import { render, staticRenderFns } from "./SecurityGuardEdit.vue?vue&type=template&id=2ce9ed7a&scoped=true&"
import script from "./SecurityGuardEdit.vue?vue&type=script&lang=js&"
export * from "./SecurityGuardEdit.vue?vue&type=script&lang=js&"
import style0 from "./SecurityGuardEdit.vue?vue&type=style&index=0&id=2ce9ed7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce9ed7a",
  null
  
)

export default component.exports